'use client';

import { useEffect } from 'react';

export function getCurrentUrl(): string {
  return window.location.pathname + window.location.search;
}

export function useRouteChange(): void {
  useEffect(() => {
    const handleRouteChange = (): void => {
      const fullPath = getCurrentUrl();
      const previousUrl = window.current_url;

      window.previous_url = previousUrl ?? '';
      window.current_url = fullPath;
    };

    handleRouteChange();

    window.addEventListener('popstate', handleRouteChange);

    const originalPushState = history.pushState.bind(history);
    const originalReplaceState = history.replaceState.bind(history);

    history.pushState = function (...args) {
      originalPushState(...args);
      handleRouteChange();
    };

    history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      handleRouteChange();
    };

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);
}

declare global {
  interface Window {
    current_url?: string;
    previous_url?: string;
  }
}
